var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFeatureTopMatchFilled = function SvgFeatureTopMatchFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    fillRule: "evenodd",
    stroke: "currentcolor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5,
    d: "M9.824 12.653H8.748a1.402 1.402 0 0 1-1.402-1.402v-1.076a.602.602 0 0 0-.175-.424l-.76-.76a1.402 1.402 0 0 1 0-1.983l.76-.76a.597.597 0 0 0 .176-.424V4.748c0-.774.628-1.402 1.402-1.402h1.075c.16 0 .312-.063.425-.175l.76-.76a1.402 1.402 0 0 1 1.983 0l.76.76a.599.599 0 0 0 .424.175h1.076c.774 0 1.402.628 1.402 1.402v1.076c0 .159.063.311.175.424l.76.76a1.402 1.402 0 0 1 0 1.983l-.76.76a.6.6 0 0 0-.175.425v1.076c0 .774-.628 1.402-1.402 1.402h-1.076a.602.602 0 0 0-.424.175l-.76.76a1.402 1.402 0 0 1-1.983 0l-.76-.76a.6.6 0 0 0-.425-.176",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    fillRule: "evenodd",
    d: "m8.475 12.004-1.797 4.938-1.281 3.52 2.546-1.632.978 2.914 1.28-3.52L12 13.287",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentcolor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5,
    d: "m8.475 12.004-1.797 4.938-1.281 3.52 2.546-1.632.978 2.914 1.28-3.52L12 13.287"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    fillRule: "evenodd",
    d: "m12 13.287 1.797 4.938 1.281 3.52.902-2.886 2.622 1.603-1.281-3.52-1.797-4.937",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentcolor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5,
    d: "m12 13.287 1.797 4.938 1.281 3.52.902-2.886 2.622 1.603-1.281-3.52-1.797-4.937"
  })));
};
export default SvgFeatureTopMatchFilled;